"use client";
import { createContext, useContext, useEffect, useReducer } from "react";
import BookmarksReducer from "@/Reducer/BookmarksReducer";

const BookmarksContext = createContext();

const getLocalBookmarksData = () => {
  if (typeof window !== "undefined") {
    try {
      let bookmarksTools = localStorage.getItem("bookmarksTools");
      let parsedBookmarksTools = JSON.parse(bookmarksTools);
      if (!Array.isArray(parsedBookmarksTools)) return [];
      return parsedBookmarksTools;
    } catch (error) {
      return [];
    }
  }
  return []; // SSR fallback
};

const BookmarksProvider = ({ children }) => {
  const [state, dispatch] = useReducer(BookmarksReducer, {
    bookmarks: [],
  });

  // Load from localStorage only on client
  useEffect(() => {
    const localData = getLocalBookmarksData();
    dispatch({ type: "INIT_BOOKMARKS", payload: localData });
  }, []);

  // Save to localStorage
  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("bookmarksTools", JSON.stringify(state.bookmarks));
    }
  }, [state.bookmarks]);

  const getBookmarksTools = (tool) => {
    dispatch({
      type: "ADD_TO_BOOKMARKS",
      payload: tool,
    });
  };

  const removeItem = (id) => {
    dispatch({ type: "REMOVE_BOOKMARK", payload: id });
  };

  const clearFilter = () => {
    dispatch({ type: "CLEAR_FILTER" });
  };

  return (
    <BookmarksContext.Provider
      value={{ ...state, getBookmarksTools, removeItem, clearFilter }}
    >
      {children}
    </BookmarksContext.Provider>
  );
};

const useBookmarksContext = () => useContext(BookmarksContext);

export { BookmarksProvider, useBookmarksContext };
